<template>
    <div>
        <header class="side-header light-skin opened-menu js-side-header">
            <div class="admin-details">



            </div>
            <div class="menu-scroll">
                <div class="side-menus">
                    <nav>
                        <ul>
                            <li><router-link :to="{ name: 'dashboard' }" class="main-menu-item"> <i class="fa fa-tachometer"></i> <span>Dashboard</span></router-link> </li>
                            <li v-for="(link, index) in links" class="main-menu-item"  :class="[{ 'active' : link.open }, { 'menu-item-has-children' : link.childLinks }]" :key="index" @click="link.open = !link.open">
                                <router-link :to="link.path" disabled> <i :class="link.icon"></i> <span>{{ link.name }}</span> </router-link>
                                <ul v-show="link.open">
                                    <li v-for="child in link.childLinks" :key="child.index"> <router-link :to="{ name: child.path }" ><i :class="child.icon"></i>  {{ child.name }} </router-link> </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div><!-- Menu Scroll -->
        </header>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dropdown: false,
                links: [
                    { name: 'Yurtlar', path: '#', icon: 'fa fa-building', open: false, childLinks: [ { name: 'Listele', path: 'dorms.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'dorms.create', icon: 'fa fa-plus' } ] },
                    { name: 'Üyeler', path: '#', icon: 'fa fa-user', open: false, childLinks: [ { name: 'Listele', path: 'users.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'users.create', icon: 'fa fa-plus' } ] },
                    { name: 'Reklamlar', path: '#', icon: 'fa fa-cart-plus', open: false, childLinks: [ { name: 'Listele', path: 'promotes.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'promotes.create', icon: 'fa fa-plus' } ] },
                    { name: 'Üniversiteler', path: '#', icon: 'fa fa-university', open: false,  childLinks: [ { name: 'Listele', path: 'universities.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'universities.create', icon: 'fa fa-plus' } ] },
                    { name: 'Fakülteler', path: '#', icon: 'fa fa-building', open: false,  childLinks: [ { name: 'Listele', path: 'faculties.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'faculties.create', icon: 'fa fa-plus' } ] },
                    { name: 'Şehirler', path: '#', icon: 'fa fa-list', open: false, childLinks: [
                            { name: 'İller', path: 'cities.list', icon: 'fa fa-list' },
                            { name: 'İlçeler', path: 'districts.list', icon: 'fa fa-list' },
                            { name: 'İl Ekle', path: 'cities.create', icon: 'fa fa-plus' },
                            { name: 'İlçe Ekle', path: 'districts.create', icon: 'fa fa-plus' }
                        ] },
                    { name: 'İlanlar', path: '#', icon: 'fa fa-bullhorn', open: false, childLinks: [ { name: 'Listele', path: 'adverts.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'adverts.create', icon: 'fa fa-plus' } ] },
                    { name: 'Haberler', path: '#', icon: 'fa fa-newspaper-o', open: false, childLinks: [ { name: 'Listele', path: 'news.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'news.create', icon: 'fa fa-plus' } ] },
                    { name: 'Sayfalar', path: '#', icon: 'fa fa-columns', open: false, childLinks: [ { name: 'Listele', path: 'pages.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'pages.create', icon: 'fa fa-plus' } ] },
                    { name: 'Blog', path: '#', icon: 'fa fa-rss', open: false, childLinks: [ { name: 'Listele', path: 'blogs.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'blogs.create', icon: 'fa fa-plus' } ] },
                    { name: 'Panel Kullanıcıları', path: '#', icon: 'fa fa-users', open: false, childLinks: [ { name: 'Listele', path: 'panel_users.list', icon: 'fa fa-list' }, { name: 'Ekle', path: 'panel_users.create', icon: 'fa fa-plus' } ] },
                    { name: 'İletişim Formu', path: '#', icon: 'fa fa-envelope', open: false, childLinks: [ { name: 'Listele', path: 'contacts.list', icon: 'fa fa-list' } ] },
                    { name: 'Mesajlar', path: '#', icon: 'fa fa-comments', open: false, childLinks: [ { name: 'Listele', path: 'messages.list', icon: 'fa fa-list' } ] },
                    { name: 'Diğer', path: '#', icon: 'fa fa-cog', open: false, childLinks: [
                            { name: 'Site Ayarları', path: 'settings.index', icon: 'fa fa-list' },
                            { name: 'Yurt Özellikleri', path: 'dorm_properties.list', icon: 'fa fa-list' },
                            { name: 'Yurt Kategorileri', path: 'dorm_categories.list', icon: 'fa fa-list' },
                            { name: 'Blog Kategorileri', path: 'blog_categories.list', icon: 'fa fa-list' },
                            { name: 'Dosya Kütüphanesi', path: 'filemanager', icon: 'fa fa-list' },
                        ] },
                ]
            }
        }
    }
</script>

<style scoped>
.main-menu-item:hover > .main-menu-item a i {
    color: #ff5f5f;
}
.opened-menu {
    height: calc(100vh - 68px);
    overflow: auto;
}
::-webkit-scrollbar {
  width: 3px;
  border-radius: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
